export const ROADMAP_DATA = [
  { translationKey: 'mini_app', isCompleted: true },
  { translationKey: 'beta_test', isCompleted: true },
  { translationKey: 'stones', isCompleted: true },
  { translationKey: 'tasks', isCompleted: true },
  { translationKey: 'friends', isCompleted: true },
  { translationKey: 'leaderboard', isCompleted: true },
  { translationKey: 'translate', isCompleted: true },
  { translationKey: 'villages', isCompleted: true },
  { translationKey: 'strategic_partnerships', isCompleted: false },
  { translationKey: 'public_launch', isCompleted: false },
  { translationKey: 'cex_negotiations', isCompleted: false },
  { translationKey: 'airdrop_tasks', isCompleted: false },
];
